import { FrontPageAction, Loading } from './actions';
import ActivitiesResponse from './domain/ActivitiesResponse';
import CarouselResponse from './domain/CarouselResponse';
import ArticlesResponse from './domain/ArticlesResponse';
import PaKryssResponse from './domain/PaKryssResponse';
import StartPuffsResponse from './domain/StartPuffsResponse';
import StartSponsorsResponse from './domain/StartSponsorsResponse';

export interface FrontPageState {
  isLoading: Loading[];
  activities: ActivitiesResponse;
  carousel: CarouselResponse;
  articles: ArticlesResponse;
  paKryss: ArticlesResponse;
  startPuffs: StartPuffsResponse;
  startSponsors: StartSponsorsResponse;
}

const initialState: FrontPageState = {
  isLoading: ['activities', 'carousel', 'articles', 'pa_kryss', 'start_puffs'],
  activities: { sxkActivities: [], groupActivities: [], organizers: [] },
  carousel: { delay: 6_000, items: [] },
  articles: { items: [] },
  paKryss: { items: [] },
  startPuffs: { items: [] },
  startSponsors: { items: [] },
};

export default function frontPageReducer(state: FrontPageState = initialState, action: FrontPageAction): FrontPageState {
  if (action.type === 'loadActivities') {
    return { ...state, activities: action.activities };
  }
  if (action.type === 'loadCarousel') {
    return { ...state, carousel: action.carousel };
  }
  if (action.type === 'loadArticles') {
    return { ...state, articles: action.articles };
  }
  if (action.type === 'loadPaKryss') {
    return { ...state, paKryss: action.paKryss };
  }
  if (action.type === 'loadStartPuffs') {
    return { ...state, startPuffs: action.startPuffs };
  }
  if (action.type === 'loadStartSponsors') {
    return { ...state, startSponsors: action.startSponsors };
  }
  if (action.type === 'startLoading') {
    const isLoading = [...new Set([...state.isLoading, action.startLoad])];
    return { ...state, isLoading };
  }
  if (action.type === 'endLoading') {
    const isLoading = new Set(state.isLoading);
    isLoading.delete(action.endLoad);
    return { ...state, isLoading: [...isLoading] };
  }
  return state;
}
